/**
 * OrdenesConsolidada.jsx · Vista Única · SOLO OT Smart.
 * ─────────────────────────────────────────────────────
 * Mesa técnica Ago 2026: se eliminaron las vistas Kanban Interno / Lista / Infraestructura.
 * `/ordenes` ahora es el alias oficial del OT Smart Inbox.
 */
import OTSmartInbox from "./OTSmartInbox";

export default function OrdenesConsolidada() {
  return <OTSmartInbox />;
}
